/**
 * Typed endpoint functions for `/api/games/*` — the game catalog
 * (docs/APP_PLAN.md §8.1, §12 M3). The catalog is driven entirely by the
 * server's registered game modules and `game_definitions.status`; this
 * client performs no filtering or interpretation of its own.
 */
import type { HttpClient } from './http-client.js';
import type { GameCatalogEntry } from './types.js';

interface GameCatalogListEnvelope {
  games: GameCatalogEntry[];
}

interface GameCatalogEntryEnvelope {
  game: GameCatalogEntry;
}

export interface GamesApi {
  /** `GET /api/games`. Only games visible in the catalog (`active`/`beta`) are returned. */
  list(): Promise<GameCatalogEntry[]>;
  /** `GET /api/games/:gameId`. */
  get(gameId: string): Promise<GameCatalogEntry>;
}

export function createGamesApi(http: HttpClient): GamesApi {
  return {
    async list() {
      const { games } = await http.request<GameCatalogListEnvelope>({
        method: 'GET',
        path: '/games',
      });
      return games;
    },

    async get(gameId) {
      const { game } = await http.request<GameCatalogEntryEnvelope>({
        method: 'GET',
        path: `/games/${encodeURIComponent(gameId)}`,
      });
      return game;
    },
  };
}
